export default "__VITE_ASSET__aa5fc2a6__"